import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import MyButton from "./myButton"; // Assuming this is a styled button component
import { useEffect, useState } from "react";
import { addDevice, getLoggedDevices, removeDevice } from "../../../Api/api";
import { utility } from "../../../utility/utility";
import { useDispatch } from "react-redux";
import { LOCAL_STORAGE_KEY } from "../../../constant";
import { useNavigate } from "react-router-dom";
import { setPrevPath, setProfiles, setUser } from "../../../redux/applicationSlice";
import moment from "moment/moment";

const DeleteDeviceConfirmationBox = ({ openDeleteDeviceDialogue, onExitDialogue, user }) => {

  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hashPath = window.location.hash.replace(/^#/, '');

  useEffect(() => {
    loadDevcices();
  }, [user]);

  const loadDevcices = async () => {
    if (!user) {
      return;
    }
    setIsLoading(true);
    let res = await getLoggedDevices(user._id);
    console.log(res);
    if (res.success) {
      setDevices(res.data.map((d, i) => {
        return {
          id: i,
          ...d
        }
      }));
    } else {
      setDevices([]);
      console.log(res);
    }
    setIsLoading(false);
  };

  const handleDelete = async (id, deviceToDelete) => {
    setIsLoading(true);
    let res = await removeDevice(user._id, deviceToDelete.serialNumber);
    if (res.success) {
      setDevices(devices.filter(device => device.id !== id));

      let addDeviceRes = await addDevice(user._id, (user.Name + '`s Device'));
      if (!addDeviceRes.success) {
        utility.setValue(LOCAL_STORAGE_KEY.user, null);
        dispatch(setUser(null));
        navigate('/login');
      } else {
        utility.setValue(LOCAL_STORAGE_KEY.user, user);
        dispatch(setUser(user));
        dispatch(setProfiles(user?.Profiles ?? []));
        dispatch(setPrevPath(hashPath));
        navigate('/');
      }

    }
    setIsLoading(false);
  };


  return (
    <Dialog
      open={openDeleteDeviceDialogue}
      onClose={() => onExitDialogue(false)}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: "#1a1c24",
          color: "white",
          padding: "20px",
          borderRadius: "12px",
          position: "relative",
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={() => onExitDialogue(false)}
        sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
      >
        <i className="fa fa-times" style={{ fontSize: "24px" }}></i>
      </IconButton>

      {/* Title */}
      <DialogTitle id="logout-dialog-title" sx={{ textAlign: "center", marginTop: "20px" }}>
        <Typography variant="h6" fontWeight="bold">
          Are you sure you want remove other device?
        </Typography>
      </DialogTitle>

      {/* Description */}
      <DialogContent>
        {isLoading ?
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
            <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px", color: "#e20074" }}></i>
          </div> :
          devices.map((device) => {
            return (
              <div key={device.id} style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
                <div
                  style={{
                    background: "#2a2c35",
                    borderRadius: "20px",
                    width: "64px",
                    height: "64px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i className="fa fa-tv" style={{ fontSize: "32px", color: "#e20074" }}></i>
                </div>
                <div style={{ marginLeft: "16px" }}>
                  <Typography variant="body1" fontWeight="bold">
                    {device.deviceName}
                  </Typography>
                  <Typography variant="body2">{moment(device.lastLoginTime).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                </div>
                {/* delete device icon*/}
                <div
                  style={{
                    background: "#2a2c35",
                    borderRadius: "10px",
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    right: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleDelete(device.id, device);
                  }}
                >
                  <i className="fa fa-trash" style={{ fontSize: "16px", color: "#e20074" }}></i>
                </div>
              </div>
            );
          })
        }
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDeviceConfirmationBox;
